//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div style="width:100%; float:left">
    <div style="float:left">
      <p style="font-size:16px; padding-top:0px;">Банки</p>
    </div>
    <div style="margin-top:-5px; padding-left:5px; float:left">
      <Button type="text" size="small" style="border-radius:3px; margin-bottom:5px; padding-top:5px;" @click="reloadOnClick">
        <Icon type="ios-loop" size="18"></Icon>
      </Button>
    </div>
    <div style="float:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="dashed" style="border-radius:3px; height:36px; margin-bottom:0px; color:#b7b7b7; text-decoration2:underline;" size2="large" @click="showDeletedItemsChangeMode"><span v-if="showDeletedItemsMode==false">АРХИВ</span><span v-else>ВЕРНУТЬСЯ ИЗ АРХИВА</span></Button>
    </div>
  </div>

  <div v-if="commonData.isLoaded == false">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="dataIsLoaded == false">
    Подождите, загружаются данные по банкам
  </div>
  <div v-else style="width:100%; float:left">

   <div :style="expandTable == true ? 'width:100%' : 'width:calc(100% - 500px)'" style="height:100%; padding-right:0px; float:left;">

    <div style="width:50px; padding-top:11px; padding-bottom:0px; display:inline-block; float:left;"><span>Фильтр</span></div>
    <div style="padding-bottom:12px; display:inline-block; width:300px">
      <Input v-model="filterValue" size="large" style="width:100%" v-on:on-change="filterValueOnChange"/>
    </div>

    <div style="float2:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="ghost" style="border-radius:3px; height:36px; margin-bottom:0px;" size="large" :disabled="(editingDataRow != null) && (editingDataRow.val.id == null)" @click="newEditingDataRowOnClick">+</Button>
    </div>

    <div v-if="showDeletedItemsMode == true" style="font-size:15px; padding-bottom:10px">
      АРХИВ БАНКОВ:
    </div>

    <div v-if="filteredRecords.length > 0">
     <div v-for="(itemData, keyData) in filteredRecords" :key="keyData" style="width:300px; height:140px; padding:20px; margin:0 10px 10px 0; border-radius:10px; float:left;"
      :style="{border: isRowSelected(itemData) == true ? '2px solid #a0a7ff' : '2px solid #aaa',
              color: isRowSelected(itemData) == true ? '#fff' : '#fff',
              background: isRowSelected(itemData) === true ? '#a0a7ff' : '#a9acb7'}"
      @click="dataRowOnSelect(itemData)"> <!--#778087-->

      <div style="margin:35px 0 10px 0; padding-bottom:5px; display:inline-block; float:left; width:calc(100% - 20px); text-align:center;">
        <Icon type="briefcase" style="font-size:19px"/>
        <span style="font-size:18px; margin-left:10px;"><b>{{itemData.val.name}}&nbsp;</b></span>
      </div>

      <!--hr style="margin:10px 0px 10px 0px; border-top-width:1px; border-top-color:#b7c0c7; width:400px; display:inline-block; clear:left;" /-->

     </div>

     <div v-if="filteredRecords.length == numOfItemsToShowWithEmptyFilter" style="clear:left">
       * Список не полный, еще много всего найдено. Используйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
     </div>
    </div>

    <div v-else>
      * Ничего не найдено. Скорректируйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
    </div>

   </div>

   <DIV style="width:500px; padding:0; float:left;" :class="(expandTable == true) ? 'hidden' : ''">
   <div style="width:250px; padding: 44px 0px 10px 20px; border-left:1px solid #ccc; height:700px; float:left;" :class="(expandTable == true) ? 'hidden' : ''">

     <div v-if="editingDataRow != null">

        <div style="width:100%; padding-top:5px; padding-bottom:20px; display:inline-block; float:left;">
          <span v-if="editingDataRow.val.id != null"><b>РЕДАКТИРОВАНИЕ :</b></span>
          <span v-else><b>НОВЫЙ БАНК :</b></span>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Имя</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.name" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Сумма от</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input-Money v-model="editingDataRow.val.body.sumOt" style="width:100%; height:32px; color:#495060;"></Input-Money>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Сумма до</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input-Money v-model="editingDataRow.val.body.sumDo" style="width:100%; height:32px; color:#495060;"></Input-Money>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Лимит клиента<br>по сумме</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.body.clientLimitSum" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Срок в днях</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.body.srokInDays" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Отрицательная ЧП</span></div>
        <div style="margin:5px 0 8px 0;padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.otricCHP" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Сумма аванса</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.body.avancSum" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Сумма возврата аванса</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.body.avancVozvrSum" style="width:100%"></Input>
        </div>

        <div style="width:200px; padding-top:8px; padding-bottom:8px; display:inline-block; float:left;"><span>Обеспечение заявки :</span></div>
        <div style="padding-top:3px; padding-bottom:8px; display:inline-block; clear:left; width:calc(100% - 200px)">&nbsp;</div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Срок в днях</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.body.obespZayavkInDays" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Сумма</span></div>
        <div style="padding-bottom:10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.body.obespZayavkSum" style="width:100%"></Input>
        </div>

        <div style="width:200px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>Стоп регионы :</span></div>
        <div style="padding-top:0px; padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 200px)">&nbsp;</div>

        <div style="width:200px; padding-top:5px; padding-bottom:3px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Крым:</span></div>
        <div style="padding-top:3px; padding-bottom:3px; display:inline-block; clear:left; width:calc(100% - 200px)">&nbsp;</div>

        <div style="width:110px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Принципал</span></div>
        <div style="padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.krimPrincipal" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Бенефициар</span></div>
        <div style="padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.krimBenificiar" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:200px; padding-top:8px; padding-bottom:3px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Севастополь:</span></div>
        <div style="padding-top:5px; padding-bottom:3px; display:inline-block; clear:left; width:calc(100% - 200px)">&nbsp;</div>

        <div style="width:110px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Принципал</span></div>
        <div style="padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.sevastopolPrincipal" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Бенефициар</span></div>
        <div style="padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.sevastopolBenificiar" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:200px; padding-top:8px; padding-bottom:3px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;СКФО:</span></div>
        <div style="padding-top:5px; padding-bottom:3px; display:inline-block; clear:left; width:calc(100% - 200px)">&nbsp;</div>

        <div style="width:110px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Принципал</span></div>
        <div style="padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.skfoPrincipal" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Бенефициар</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.body.skfoBenificiar" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <!--div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Идентификатор</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{editingDataRow.val.id}}&nbsp;
        </div-->

     </div>

     <!--div v-else>
       * Выберите запись для просмотра или редактирования
       <br><br><br>
     </div-->

   </div>

   <div style="width:250px; padding: 80px 0px 10px 20px; float:left;" :class="(expandTable == true) ? 'hidden' : ''">

     <div v-if="editingDataRow != null">

        <div style="width:calc(100% - 15px);; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Совместная закупка БГ</span></div>
        <div style="margin:5px 0 0px 0;padding-bottom:5px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.sovmesZakupBG" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:110px; padding-top:8px; padding-bottom:5px; display2:inline-block; float:left;"><span>З.223 сумма БГ</span></div>
        <div style="width:25px; margin:5px 0 8px 0; padding-bottom:5px; display:inline-block; float:left;">
          <Checkbox v-model="editingDataRow.val.body.zakon223" size="small" style="margin:3px 0 0 0;"></Checkbox>
        </div>
        <div style="padding-bottom:5px; display2:inline-block; float:left; width:calc(100% - 135px)">
          <Input v-model="editingDataRow.val.body.zakon223Sum" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:8px; padding-bottom:5px; display2:inline-block; float:left;"><span>З.615 сумма БГ</span></div>
        <div style="width:25px; margin:5px 0 8px 0; padding-bottom:5px; display:inline-block; float:left;">
          <Checkbox v-model="editingDataRow.val.body.zakon615" size="small" style="margin:3px 0 0 0;"></Checkbox>
        </div>
        <div style="padding-bottom:5px; display2:inline-block; float:left; width:calc(100% - 135px)">
          <Input v-model="editingDataRow.val.body.zakon615Sum" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:8px; padding-bottom:5px; display2:inline-block; float:left;"><span>З.215 сумма БГ</span></div>
        <div style="width:25px; margin:5px 0 8px 0; padding-bottom:5px; display:inline-block; float:left;">
          <Checkbox v-model="editingDataRow.val.body.zakon215" size="small" style="margin:3px 0 0 0;"></Checkbox>
        </div>
        <div style="padding-bottom:5px; display2:inline-block; float:left; width:calc(100% - 135px)">
          <Input v-model="editingDataRow.val.body.zakon215Sum" style="width:100%"></Input>
        </div>

        <div style="width:135px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Коммерция<br>сумма БГ</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 135px)">
          <Input v-model="editingDataRow.val.body.zakonKommercSum" style="width:100%"></Input>
        </div>

        <div style="width:calc(100% - 15px);; padding-top:5px; padding-bottom:10px; display:inline-block; float:left;"><span>Закрытые торги</span></div>
        <div style="margin:5px 0 0px 0;padding-bottom:5px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.zakritTorgi" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 50px); padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>ГО :</span></div>
        <div style="padding-top:3px; padding-bottom:5px; display:inline-block; clear:left; width:50px">&nbsp;</div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Только вместе с исполнением</span></div>
        <div style="margin:5px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.GOispolnenie" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 15px); padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Только если БГ в банке</span></div>
        <div style="margin:0px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.GOesliBG" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:135px; padding-top:5px; padding-bottom:5px; display:inline-block; float:left;"><span>&nbsp;&nbsp;&nbsp;Сумма</span></div>
        <div style="margin:3px 0 8px 0;padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 135px)">
          <Input v-model="editingDataRow.val.body.GOsum" style="width:100%"></Input>
        </div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Пролонгация</span></div>
        <div style="margin:8px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.prolongacia" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Переобеспечение</span></div>
        <div style="margin:8px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.pereobespechenie" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Нерезидент директор/учредитель</span></div>
        <div style="margin:8px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.nerezident" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Патентная система</span></div>
        <div style="margin:8px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.patent" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Предмет - строительство</span></div>
        <div style="margin:8px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.stroitelstvo" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:calc(100% - 15px); padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Оплата от 3-его лица</span></div>
        <div style="margin:8px 0 0px 0;padding-bottom:0px; display:inline-block; clear:left; width:15px">
          <Checkbox v-model="editingDataRow.val.body.oplata3lico" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

     </div>

   </div>

   <div style="width:500px; padding: 0px 0px 10px 20px; border-left:1px solid #ccc; min-height:calc(100vh - 850px); float:left;" :class="(expandTable == true) ? 'hidden' : ''">

     <div v-if="editingDataRow != null">

        <div style="padding: 15px 0px 0px 0px;">
          <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveEditingDataRowOnClick">Сохранить</Button>
          <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelEditingDataRowOnClick">Отменить</Button>
          <Button type="ghost" style="float:right; border-radius:3px; margin-bottom:10px; padding-top:5px; color:#d7d7d7;" :class="editingDataRow.val.id == null ? 'hidden' : ''" @click="deleteEditingDataRowOnClick">
            <Icon type="trash-b" size="18"></Icon>
            <Icon type="ios-redo" size="18" v-if="editingDataRow.val.deleted == true"></Icon>
          </Button>
        </div>

     </div>

   </div>
   </DIV>

  </div>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import arrayTools from '@/technical/arrayTools/arrayTools'

import serverData from '@/store/serverData'

export default {
  components: { },
  data () {
    return {
      // usersAccessAsOffice: {'5': true, '7': true, '8': true, '11': true, '95': true}, // Тюрин, Ремезова, Малюгина, Егор, Белов

      data: [], // list of FinixBanks
      filteredRecords: [],

      // UI FIELDS
      dataIsLoaded: false,
      numOfItemsToShowWithEmptyFilter: 50,
      showDeletedItemsMode: false,

      filterValue: '',

      expandTable: true,

      loadingSpinner: false,

      selectedDataRow: null,
      editingDataRow: null
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData'
    ])
  },
  created: function () {
    var thisRef = this
    this.data = serverData.finixBanks // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event FinixBanksChanged
    thisRef.dataIsLoaded = true // !!! т к это CommonData то когда commonData.isLoaded == true то сразу ставим и dataIsLoaded = true

    serverData.finixBanksOnDestroyDelegates.push(this.deleteDataRecDelegate)

    serverData.eventsBus.$on('finixBanksChanged', (data) => {
      // console.log('on finixBanksChanged')
      // console.log(data)
      /* if (this.editingDataRec.val.id === data.record.id) {
        this.editingDataRec.val = Object.assign({}, data.record)
      } */
      if (data.method === 'read') thisRef.dataIsLoaded = true
      thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    })

    // если это не перезагрузка данной страницы то serverData уже давно бы был и тут бы мы строили список наших отображаемых данных
    // но это только для CommonData, т е тех что загружаются в приложени по умолчанию. а наши данные надо тут указать что грузим
    thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    // serverData.finixBanksReload(function () {}) // вместо callback функционал сработает через serverData.eventsBus.$on('finixBanksChanged')
  },
  methods: {
    ...mapMutations([
      'commonDataIsLoadedSet'
    ]),
    reloadOnClick () {
      var thisRef = this
      // thisRef.data = [] // трется внутри serverData.reload
      thisRef.dataIsLoaded = false

      serverData.finixBanksReload(function (err) {
        if (err) return serverErrorHandling(err, thisRef)
        // вместо этих строк работает serverData.eventsBus.$on('finixBanksChanged', (data))
        // thisRef.data = serverData.finixBanks // data так и смотрела на serverData которые не перезаписывались а стирались и добавлялись
        // thisRef.filterValueOnChange()
      })
    },
    filterValueOnChange () {
      this.filteredRecords.splice(0, this.filteredRecords.length)

      if (this.data.length === 0) return

      for (let i = this.data.length - 1; i >= 0; i--) {
        if ((this.showDeletedItemsMode === false) && (this.data[i].val.deleted === true)) continue // !!! НЕ ИЩЕМ В УДАЛЕННЫХ
        if ((this.showDeletedItemsMode === true) && (this.data[i].val.deleted === false)) continue // !!! НЕ ИЩЕМ НЕ В УДАЛЕННЫХ
        // if ((this.usersAccessAsOffice[this.activeUser.id] !== true) && (this.data[i].val.GroupID === 2)) continue // !!! ИЩЕМ ТОЛЬКО В 'ПОКУПАТЕЛЯХ', не в 'ПОСТАВЩИКАХ' и т.д.

        if (this.filterValue.length < 3) {
          if (this.filteredRecords.length < this.numOfItemsToShowWithEmptyFilter) this.filteredRecords.push(this.data[i])
          continue
        }

        if (this.data[i].val.id.toString().indexOf(this.filterValue) !== -1) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.INN != null) && (this.data[i].val.INN.indexOf(this.filterValue) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.Phone != null) && (this.data[i].val.Phone.indexOf(this.filterValue) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        var filterValueLowerCase = this.filterValue.toLowerCase()
        if ((this.data[i].val.Name != null) && (this.data[i].val.Name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.ContactName != null) && (this.data[i].val.ContactName.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.City != null) && (this.data[i].val.City.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.Address != null) && (this.data[i].val.Address.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
      }

      arrayTools.sort(this.filteredRecords, function (a, b) {
        return a.val.name > b.val.name
      })
    },

    newEditingDataRowOnClick () {
      var newEntity = restResource(this.appSettings.server.host + this.appSettings.server.finixBankResource)
      newEntity.val = {}
      newEntity.val.name = ''
      newEntity.val.body = {}
      newEntity.val.body.sumOt = ''
      newEntity.val.body.sumDo = ''
      newEntity.val.body.clientLimitSum = ''
      newEntity.val.body.srokInDays = ''
      newEntity.val.body.otricCHP = false
      newEntity.val.body.avancSum = ''
      newEntity.val.body.avancVozvrSum = ''
      newEntity.val.body.obespZayavkInDays = ''
      newEntity.val.body.obespZayavkSum = ''
      newEntity.val.body.sovmesZakupBG = false
      newEntity.val.body.zakon223 = false
      newEntity.val.body.zakon223Sum = ''
      newEntity.val.body.zakon615 = false
      newEntity.val.body.zakon615Sum = ''
      newEntity.val.body.zakon215 = false
      newEntity.val.body.zakon215Sum = ''
      newEntity.val.body.zakonKommercSum = ''
      newEntity.val.body.zakritTorgi = false
      newEntity.val.deleted = false // Not deleted

      this.selectedDataRow = null
      this.editingDataRow = Object.assign({}, newEntity)
      this.editingDataRow.val = Object.assign({}, newEntity.val)

      this.expandTable = false // to show newEntity editing
    },

    cancelEditingDataRowOnClick () {
      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
    },

    saveEditingDataRowOnClick () {
      if (this.editingDataRow.val.Name === '') return this.$message.error('Введите имя')

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      thisRef.editingDataRow.save()
      .then(function (response) {
        thisRef.loadingSpinner = false
        loading.close()

        thisRef.selectedDataRow = null
        thisRef.editingDataRow = null
        thisRef.expandTable = true

        /* serverData.finixBanksReload(function (err) {
          if (err) return serverErrorHandling(err, thisRef)
          thisRef.data = serverData.finixBanks
          thisRef.filterValueOnChange()
        }) */

        // thisRef.$message.success('Запись сохранена на сервер')
      })
      .catch(function (error) {
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(error, thisRef)
      })
    },

    deleteEditingDataRowOnClick () {
      if (this.editingDataRow.val.deleted === false) this.editingDataRow.val.deleted = true // delete (archive)
      else this.editingDataRow.val.deleted = false // undelete (return from archive trashbox)

      this.saveEditingDataRowOnClick()
      // this.filterValueOnChange()

      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
    },

    deleteDataRecDelegate (deletedRecord, cb) {
      /* var thisRef = this
      if ((thisRef.editingDataRec != null) && (deletedRecord.id === thisRef.editingDataRec.val.id)) {
        thisRef.editingDataRec = null
      } */
      return cb()
    },

    showDeletedItemsChangeMode () {
      this.showDeletedItemsMode = !this.showDeletedItemsMode
      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
      this.filterValueOnChange()
    },

    dataRowOnSelect (value) {
      // !!!!!!! console.log('finixBanks dataRowOnSelect')
      // !!!!!!! console.log(this.data[0].val.body.otricCHP)
      // !!!!!!! console.log(value.val.body.otricCHP)
      this.selectedDataRow = value
      this.editingDataRow = Object.assign({}, value)
      this.editingDataRow.val = Object.assign({}, value.val)
      this.editingDataRow.val.body = Object.assign({}, value.val.body)
      this.expandTable = false
    },

    isRowSelected (row) {
      if (this.selectedDataRow == null) return false
      if (row.val.id === this.selectedDataRow.val.id) return true
      else return false
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.top-panel-expand-table-button {
  margin: 0px;
  pading: 0px;
  font-size: 17px;
  color: #5a5a5a;
  cursor: pointer;
}
.top-panel-expand-table-button:hover {
  color: #000;
}
.datalist{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.datalist-scroll {
  overflow-y: scroll;   /* надо чтобы работал scroll для mainMenu */
  height: calc(100vh - 200px);
  /* width: 257px; /* минимум на 17 пикселей больше чем mainmenu-panel.width, ща сделал на 50 больше */
}
hr {
  /*border: none; /* Убираем границу для браузера Firefox */
  /*color: #ccc; /* Цвет линии для остальных браузеров */
  /*background-color: #ccc; /* Цвет линии для браузера Firefox и Opera */
  /*height: 1px; /* Толщина линии */
  margin: 10px 0 15px 0;
  margin: 50px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.incomesAndExpensesTextarea textarea.ivu-input {
  font-size: 12px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// FinixBanks.vue?28d6cc36